import * as React from 'react';
import api from '../../api';
import { MediaFile } from '../../core';
import { useDataLoader } from 'react-remote-data-hooks';

import noImage from '../../assets/images/user-noimage.png';

interface IAvatarImage {
  image?: MediaFile;
  className?: string;
  index?: number;
  height?: number;
}

export const AvatarImage: React.FunctionComponent<IAvatarImage> = (props) => {
  const { data: signedUrl, reload, loaded } = useDataLoader<string>(
    async (mediaFile?: MediaFile) =>
      mediaFile ? api.upload.getSignedMediaFileUrl(mediaFile) : undefined,
    [props.image]
  );

  React.useEffect(() => {
    if (loaded) {
      reload(props.image);
    }
  }, [props.image]);

  return (
    <img
      height={props.height}
      src={signedUrl || noImage}
      className={props.className}
      alt=""
    />
  );
};
